import {useContext} from 'react';
import {useParams, useRouteMatch} from 'react-router-dom';
import {SeniorCaregiversListing} from '../../../../../../../components/senior-caregivers-listing/senior-caregivers-listing';
import {OfficeContext} from '../../../../../../../contexts/office/context';
import {OfficeContextType} from '../../../../../../../contexts/office/types';
import {ScreenPaths} from '../../../../../../../enums/screen-path';
import {CaregiverMode} from '../../../../../../../enums';

export default function SeniorInformalCaregiverSystemAdministratorOfficeScreen() {
  let {id}: {id?: string} = useParams();
  const officeContext: OfficeContextType = useContext(OfficeContext);
  let {url} = useRouteMatch();

  return (
    <SeniorCaregiversListing
      seniorId={id || ''}
      seniorName={officeContext.state.userForm?.user.name || ''}
      invitesHistoryUrl={url.charAt(url.length - 1) === '/' ? `${url}invites` : `${url}/invites`}
      inviteCaregiverUrl={url.charAt(url.length - 1) === '/' ? `${url}invite` : `${url}/invite`}
      caregiverRowBaseLinkUrl={`${ScreenPaths.Office}${ScreenPaths.Office_SystemAdministrator}${ScreenPaths.SystemAdministrator_Caregivers}`}
      caregiverMode={CaregiverMode.SystemAdministrator}
      url={url}
    />
  );
}
